import * as React from 'react'
function SvgTriangleUp(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M19.998 10c-.57 0-1.106.278-1.433.747l-12.25 17.5A1.75 1.75 0 007.748 31H32.25a1.748 1.748 0 001.433-2.753l-12.25-17.5A1.742 1.742 0 0020.002 10h-.004c.002 0 .002 0 0 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTriangleUp
